import { Breadcrumb, IBreadcrumbItem, Stack, useTheme } from "@bps/fluent-ui";

interface BreadcrumbProps {
  items: IBreadcrumbItem[];
  marginBottom?: number;
}

export const Breadcrumbs = ({ items, marginBottom = 16 }: BreadcrumbProps) => {
  const theme = useTheme();
  return (
    <Stack
      styles={{
        root: {
          marginBottom,
          backgroundColor: theme.palette.white
        }
      }}
    >
      <Breadcrumb
        styles={{
          root: {
            margin: 0
          }
        }}
        items={items}
      />
    </Stack>
  );
};
